import { Service } from '@angular/core';
import { ConfAndLiveRights, LiveParticipant } from '@shared/models/live';
import { syncState } from '@shared/utils/sync-state';

const DEFAULT_RIGHTS: ConfAndLiveRights = {
  canApproveParticipant: false,
  canChangeLayout: false,
  canViewChat: false,
  canWriteChat: false,
  canControlCamera: false,
  canDraw: false,
  canGiveRigths: false,
  canInvite: false,
  canKick: false,
  canLaser: false,
  canMute: false,
  canPauseLive: false,
  canRecord: false,
  canSendAudio: false,
  canShareLink: false,
  canStopLive: false,
  canStreamVideo: false,
  canWhiteboard: false,
  canControlHeadset: false,
  canManageMask: false,
  canManageBookmark: false,
  canJoin: false,
  canSendMessage: false,
  canSendVideo: false,
  canShareFile: false,
  canShareScreen: false,
  canStream: false,
  canUpdatePermissions: false,
  canUseAi: false,
};

const RIGHTS_MAP: Partial<Record<keyof ConfAndLiveRights, string>> = {
  canShareScreen: 'canShareScreen',
  canRecord: 'canRecord',
  canSendAudio: 'canSendAudio',
  canStreamVideo: 'canSendVideo',
  canKick: 'canKick',
  canInvite: 'canInvite',
  canGiveRigths: 'canUpdatePermissions',
  canLaser: 'canLaser',
  canApproveParticipant: 'canAcceptParticipant',
  canDraw: 'canDraw',
  canWhiteboard: 'canWhiteboard',
  canChangeLayout: 'canChangeLayout',
  canControlCamera: 'canControlCamera',
  canViewChat: 'canViewChat',
  canWriteChat: 'canWriteChat',
  canPauseLive: 'canPauseLive',
  canStopLive: 'canStopLive',
  canMute: 'canMute',
  canControlHeadset: 'canControlHeadset',
  canManageMask: 'canManageMask',
  canManageBookmark: 'canManageBookmark',
  canUseAi: 'canUseAi',
};

@Service()
export class CurrentParticipantRights {
  private readonly permissions = syncState<ConfAndLiveRights>({ ...DEFAULT_RIGHTS });
  readonly currentPermissions = this.permissions.value;
  readonly currentPermissions$ = this.permissions.changes$;

  public updateParticipantRights(participant: LiveParticipant) {
    const appRights = participant?.appRights ?? [];
    const updated = { ...DEFAULT_RIGHTS };

    for (const [right, permission] of Object.entries(RIGHTS_MAP) as [keyof ConfAndLiveRights, string][]) {
      updated[right] = appRights.includes(permission);
    }

    this.permissions.set(updated);
  }

  resetState() {
    this.permissions.set({ ...DEFAULT_RIGHTS });
  }
}
